import { createSelector } from 'reselect'

import { RootState } from '../../types'

export const selectState = createSelector(
  (s: RootState) => s.accountNotifications,
  b => b
)

export const selectConfig = createSelector(
  (state: RootState) => state.config,
  c => c
)

export const areAccountNotificationsLoading = createSelector(selectState, s => s.loading)

export const getAccountNotifications = createSelector(selectState, s => s.data)

export const getAccountNotificationTemplates = createSelector(selectState, s => s.templates)

// eslint-disable-next-line lodash/prefer-constant
export const getUnreadNotificationsCount = createSelector(selectState, s => s.stats.unreadCount)

export const getAccountNotificationsPageSize = createSelector(
  selectConfig,
  c => c.pageSizes['archiveNotifications'] || 10
)
